import { Gutter } from '../types';

export const gutter: Gutter = { xsmall: 10, small: 16, medium: 24, large: 32, xlarge: 40, '2xlarge': 44 };
